import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function destinationInlandLocations(params) {
  return request({
    url: URL.booking.destinationInlandLocation.list,
    method: 'get',
    params
  })
}

